/* eslint-disable max-len */

export const testAudio = [
  {
    audio: { src: { id: `mp3/f0f74f_35a1cdce4973490eac49e74c3244364d.mp3` } },
    name: 'Dear Fear',
    authorName: 'KOTA The Friend',
  },
  {
    audio: { src: { id: `mp3/cd2f8a_5441102f2e064454bcf81979189079dc` } },
    name: 'SampleAudio_0',
  },
];

export const testUploadedVideos = [
  {
    id: 'video/11062b_44ccd80751f749449aa3190c50d30535/1080p/mp4/file.mp4',
    thumbnail: {
      pathname: 'media/11062b_44ccd80751f749449aa3190c50d30535f000.jpg',
      width: 2560,
      height: 1440,
    },
  },
  {
    id: 'video/11062b_82db3f447bd042d1bac84a88e207ed28/1080p/mp4/file.mp4',
    thumbnail: {
      pathname: 'media/11062b_82db3f447bd042d1bac84a88e207ed28f000.jpg',
      width: 1920,
      height: 1080,
    },
  },
  {
    id: 'video/11062b_b8150d3b15684fc09fa4737d2b79261d/1080p/mp4/file.mp4',
    thumbnail: {
      pathname: 'media/11062b_b8150d3b15684fc09fa4737d2b79261df000.jpg',
      width: 2560,
      height: 1440,
    },
  },
];

export const testImages = [
  {
    url: '2068b1_3ec91e9ad0d94f78b27f4cd17bb47801~mv2.png',
    photoId: 'bda539f51fc825a402cc804337859bab',
    metadata: {
      name: 'bda539f51fc825a402cc804337859bab',
      height: 1536,
      width: 1024,
      size: 2778422,
      lastModified: 1743496324,
    },
  },
  {
    url: '2068b1_692c31986dd2402e938a432ea23f6e4d~mv2.png',
    photoId: '9936b00aa3d725fc682dfc4b3fe5ed5c',
    metadata: {
      name: '9936b00aa3d725fc682dfc4b3fe5ed5c',
      height: 1536,
      width: 1024,
      size: 2641709,
      lastModified: 1743496124,
    },
  },
  {
    url: '2068b1_fc4c07bbce914b6b9658ee30f469cb5b~mv2.png',
    photoId: '04f215ba3ce22b3afcdb241ed6ff0dae',
    metadata: {
      name: '04f215ba3ce22b3afcdb241ed6ff0dae',
      height: 1536,
      width: 1024,
      size: 3890487,
      lastModified: 1743496124,
    },
  },
  {
    url: '2068b1_aa8c6d1b8c9f427eb67cf20764cf466a~mv2.png',
    photoId: 'e149632651c5f37d826a1d56a3890c3f',
    metadata: {
      name: 'e149632651c5f37d826a1d56a3890c3f',
      height: 1536,
      width: 1024,
      size: 3087920,
      lastModified: 1743495150,
    },
  },
  {
    url: '2068b1_de4af4b7991f4650ac02c1c1a7f7715f~mv2.png',
    photoId: 'f076c5bd1dd0b597afdfb84f4471394d',
    metadata: {
      name: 'f076c5bd1dd0b597afdfb84f4471394d',
      height: 1536,
      width: 1024,
      size: 2676645,
      lastModified: 1743494895,
    },
  },
  {
    url: '2068b1_7e7dcb8ffbdd4dfbbca63b52be0b633a~mv2.png',
    photoId: 'b2b1bf89d796ffeac5cf102b62d9b1d0',
    metadata: {
      name: 'b2b1bf89d796ffeac5cf102b62d9b1d0',
      height: 1024,
      width: 1024,
      size: 2286631,
      lastModified: 1743494536,
    },
  },
  {
    url: '2068b1_e3fd0b35c1b945efb8605b88eb04c0c4~mv2.png',
    photoId: '4ee499e93e62a1884e3dd6117de37078',
    metadata: {
      name: '4ee499e93e62a1884e3dd6117de37078',
      height: 1024,
      width: 1024,
      size: 2401405,
      lastModified: 1743494251,
    },
  },
  {
    url: '2068b1_c4eaaf25235146eea819133f0ac4f3a1~mv2.webp',
    photoId: 'e720356d79858d5a2b9c00633989243f',
    metadata: {
      name: 'e720356d79858d5a2b9c00633989243f',
      height: 1536,
      width: 1024,
      size: 3178584,
      lastModified: 1743493880,
    },
  },
  {
    url: '2068b1_35e7953d1f364ba49c1cb41419a9c4ac~mv2.png',
    photoId: '6b4b966b5284c01bb49ce0d4ce5e2d92',
    metadata: {
      name: '6b4b966b5284c01bb49ce0d4ce5e2d92',
      height: 1536,
      width: 1024,
      size: 3061676,
      lastModified: 1743493880,
    },
  },
  {
    url: '2068b1_b80039272a2445b9a3092a9b53c7dd95~mv2.webp',
    photoId: 'a401d78e531af8ad04f4820c39ccc4ec',
    metadata: {
      name: 'a401d78e531af8ad04f4820c39ccc4ec',
      height: 1536,
      width: 1024,
      size: 3423361,
      lastModified: 1743493876,
    },
  },
  {
    url: '2068b1_f6744a70ebaf475ba7ff301f5b90c71b~mv2.webp',
    photoId: '5bea9ae23863af877b8d44211c554c3e',
    metadata: {
      name: '5bea9ae23863af877b8d44211c554c3e',
      height: 1536,
      width: 1024,
      size: 3015150,
      lastModified: 1743493876,
    },
  },
  {
    url: '2068b1_af7e9b63151547f9a13be99f25af7508~mv2.png',
    photoId: '78d1bac04f5c70adc4a18b4ee5fa1789',
    metadata: {
      name: '78d1bac04f5c70adc4a18b4ee5fa1789',
      height: 1536,
      width: 1024,
      size: 3047667,
      lastModified: 1743493876,
    },
  },
  {
    url: '2068b1_692f91a03efd407bb7dd9c8f6ac0c955~mv2.png',
    photoId: '67ea59de847def4b4ee58ea5f5a7957d',
    metadata: {
      name: '67ea59de847def4b4ee58ea5f5a7957d',
      height: 1024,
      width: 1024,
      size: 1777293,
      lastModified: 1743493876,
    },
  },
  {
    url: '2068b1_754f77c1078f411480443fd96b681ed3~mv2.png',
    photoId: 'a85a0f6a11d9f77cebc836ccdea1c73c',
    metadata: {
      name: 'a85a0f6a11d9f77cebc836ccdea1c73c',
      height: 271,
      width: 237,
      size: 137424,
      lastModified: 1743493680,
    },
  },
];

export const testVideos = [
  {
    version: '1.0',
    thumbnail_url: 'https://i.ytimg.com/vi/jhXlnvYZZQs/hqdefault.jpg',
    provider_url: 'https://www.youtube.com/',
    thumbnail_height: 360,
    provider_name: 'YouTube',
    width: 480,
    title: 'Wix.com Official 2018 Big Game Ad with Rhett & Link — Extended Version',
    author_url: 'https://www.youtube.com/user/Wix',
    html: '<iframe width="480" height="270" src="https://www.youtube.com/embed/jhXlnvYZZQs?feature=oembed" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>',
    height: 270,
    author_name: 'Wix.com',
    thumbnail_width: 480,
    type: 'video',
    video_url: 'https://youtu.be/jhXlnvYZZQs',
  },
  {
    height: 270,
    author_name: 'Wix.com',
    html: '<iframe width="480" height="270" src="https://www.youtube.com/embed/BBu5codsO6Y?feature=oembed" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>',
    thumbnail_width: 480,
    type: 'video',
    version: '1.0',
    thumbnail_height: 360,
    provider_url: 'https://www.youtube.com/',
    title: 'iJustine | Create a Website with Wix Artificial Design Intelligence',
    thumbnail_url: 'https://i.ytimg.com/vi/BBu5codsO6Y/hqdefault.jpg',
    author_url: 'https://www.youtube.com/user/Wix',
    provider_name: 'YouTube',
    width: 480,
    video_url: 'https://youtu.be/BBu5codsO6Y',
  },
  {
    author_name: 'Wix.com',
    width: 480,
    thumbnail_url: 'https://i.ytimg.com/vi/_zuIxexRrtk/hqdefault.jpg',
    thumbnail_width: 480,
    provider_url: 'https://www.youtube.com/',
    type: 'video',
    height: 270,
    author_url: 'https://www.youtube.com/user/Wix',
    version: '1.0',
    provider_name: 'YouTube',
    thumbnail_height: 360,
    title: 'How to Build a Wix Website for Your Business | James Veitch',
    html: '<iframe width="480" height="270" src="https://www.youtube.com/embed/_zuIxexRrtk?feature=oembed" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>',
    video_url: 'https://youtu.be/_zuIxexRrtk',
  },
];
